var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-nav',{attrs:{"navId":_vm.PL_NAV_KEY}})
}
var staticRenderFns = []

export { render, staticRenderFns }